const formCheckboxContainer = {
  update: (field, appData) => {
    const value = formCheckboxContainer.extractFieldValue(field);
    const fieldsArray = appData.screenValidation.fields;
    const index = fieldsArray.findIndex(
      fieldItem => fieldItem.fieldName === field.name
    );
    const savedValue =
      appData.values[field.name] || appData.values[field?.options?.[0]?.value];
    const { settings } = appData;
    const fieldObject = {
      fieldName: field.name,
      isValid: formCheckboxContainer.validate(field, value, savedValue),
      isRequired: formCheckboxContainer.isRequired(field),
      errorMessage: formCheckboxContainer.getErrorMessage(
        field,
        value,
        settings
      ),
      groupErrorMessage: formCheckboxContainer.getFormGroupErrorMessage(
        field,
        value,
        settings
      ),
      value,
      title: field.title
    };
    if (index > -1) {
      fieldsArray[index] = fieldObject;
    } else {
      fieldsArray.push(fieldObject);
    }
    return fieldObject;
  },

  updateOption({ options, name }, checked, optionName) {
    let currentOption =
      options &&
      options.length > 1 &&
      options.find(
        option => option.name === optionName || option.name === name
      );

    if (!currentOption && options.length === 1) {
      // eslint-disable-next-line
      currentOption = options[0];
    }

    if (currentOption) {
      currentOption.selected = checked;
    }
  },

  getErrorMessage: (field, value, settings) => {
    // TODO: add logic for extracting error message
    if (formCheckboxContainer.isAgreementRequired(field, value)) {
      return settings.translations.accept_required_agreements;
    }
    if (formCheckboxContainer.isRequired(field)) {
      if (field.options.length === 1) {
        return settings.translations.checkbox_required;
      } else {
        return settings.translations.choose_one_above;
      }
    }
    return null;
  },

  getFormGroupErrorMessage: (field, value, settings) => {
    if (formCheckboxContainer.isAgreementRequired(field, value)) {
      return settings?.translations?.required_agreement;
    }

    return null;
  },

  extractFieldValue({ options }) {
    return !!(options && options.find(option => option.selected));
  },

  validate: (field, value, savedValue) => {
    const isAgreement = field.params.includes("TDFieldOptionIsAgreement");
    const isChecked = isAgreement
      ? savedValue === "Y" || savedValue?.accepted || value
      : value === "Y" || !!value;
    return !!(isChecked || field.params.includes("TDFieldOptionIsOptional"));
  },

  isRequired: field => !field.params.includes("TDFieldOptionIsOptional"),

  isAgreementRequired: (field, value) =>
    formCheckboxContainer.isRequired(field) &&
    field.params.includes("TDFieldOptionIsAgreement") &&
    !value
};

export default formCheckboxContainer;
